import { createResetStateMutation } from '@/helpers';
import { loteIdsMatch } from '@/helpers/loteAdicionales';
import { getInitialStatePoliza, initialStateLote } from './state';

export const setPolicy = (state, data) => {
   state.poliza = { ...state.poliza, ...data };
};

export const setPolicies = (state, data) => {
   state.polizas = data;
};

export const updatePol = (state, { key, value }) => {
   state.poliza[key] = value;
};

export const setPoliciesAsignadas = (state, data) => {
   state.casosAsignados = data;
};
export const setProspects = (state, data) => {
   state.prospectosAsignados = data;
};

export const setRetomado = (state, value) => {
   state.retomado = value;
};

export const updateLoteCoords = (
   state,
   { loteId, coordenadas, isMapaLoaded },
) => {
   const loteIndex = state.lotes.findIndex((lote) => lote.id === loteId);
   if (loteIndex !== -1) {
      state.lotes[loteIndex].initialCoords = coordenadas;
      state.lotes[loteIndex].isMapaLoaded = isMapaLoaded;
   }
};

export const updateProspect = (state, data) => {
   const index = state.prospectosAsignados.findIndex(
      (e) => e.id_poliza === Number(data.id_poliza),
   );
   state.prospectosAsignados[index].id_estado = data.id_estado;
   state.seguimientos = data.seguimientos;
};

export const setSeguimientos = (state, data) => {
   state.seguimientos = data;
};

export const setComentarios = (state, data) => {
   state.comentarios = data;
};

export const setEstados = (state, estados) => {
   state.estados = estados;
};

export const setSecciones = (state, secciones) => {
   state.secciones = secciones;
};

export const setProspectsTable = (state, data) => {
   state.polizas = data;
};

// Estado paginado de pólizas (vigentes)
export const resetPolizasList = (state, filters) => {
   state.polizasList.items = [];
   state.polizasList.offset = 0;
   state.polizasList.limit = 50;
   state.polizasList.finished = false;
   const defaultFilters = {
      cliente: '',
      usuario: '',
      empresa: '',
      ramo: null,
      numero: '',
      fecha_desde: null,
      fecha_hasta: null,
   };
   state.polizasList.filters = {
      ...defaultFilters,
      ...(filters && typeof filters === 'object' ? filters : {}),
   };
};

export const appendPolizas = (state, items) => {
   state.polizasList.items = [...state.polizasList.items, ...items];
   state.polizasList.offset = state.polizasList.items.length;
};

export const setPolizasLoading = (state, loading) => {
   state.polizasList.loading = loading;
};

export const setPolizasFinished = (state, finished) => {
   state.polizasList.finished = finished;
};

// Estado paginado de solicitudes / prospectos
export const resetSolicitudesList = (state, filters) => {
   state.solicitudesList.items = [];
   state.solicitudesList.offset = 0;
   state.solicitudesList.limit = 50;
   state.solicitudesList.finished = false;
   const defaultFilters = {
      cliente: '',
      usuario: '',
      empresa: '',
      ramo: null,
      numero: '',
      estado: null,
      fecha_creacion_desde: null,
      fecha_creacion_hasta: null,
   };
   state.solicitudesList.filters = {
      ...defaultFilters,
      ...(filters && typeof filters === 'object' ? filters : {}),
   };
};

export const appendSolicitudes = (state, items) => {
   state.solicitudesList.items = [...state.solicitudesList.items, ...items];
   state.solicitudesList.offset = state.solicitudesList.items.length;
};

export const setSolicitudesLoading = (state, loading) => {
   state.solicitudesList.loading = loading;
};

export const setSolicitudesFinished = (state, finished) => {
   state.solicitudesList.finished = finished;
};
export const updateLote = (state, { key, value }) => {
   state.lote[key] = value;
};

export const addLote = (state, data) => {
   const newId = state.nextLoteId || 1;
   state.nextLoteId = newId + 1;
   const newLote = Object.assign({}, data, {
      id: newId,
      id_poliza: state.poliza.id_poliza,
   });
   state.lotes.push(newLote);
   // state.lotes = [...state.lotes, { ...data, id: newId }];
   state.lote = { ...initialStateLote };
};

export const editLote = (state, data) => {
   state.lotes = state.lotes.map((lote) => {
      if (lote.id === data.id) {
         return Object.assign({}, lote, data);
      }
      return Object.assign({}, lote);
   });
   state.lote = { ...initialStateLote };
};

export const deleteLote = (state, id) => {
   state.lotes = state.lotes.filter((e) => e.id !== id);
};

export const setArtPoliza = (state, id_art_poliza) => {
   state.poliza = { ...state.poliza, id_art_poliza };
};

export const setLote = (state, lote) => {
   state.lote = lote;
};

export const setLotes = (state, lotes) => {
   state.lotes = lotes;

   // Calcular el siguiente ID basado en los lotes existentes
   if (lotes && lotes.length > 0) {
      const maxId = Math.max(...lotes.map((lote) => lote.id || 0));
      state.nextLoteId = maxId + 1;
   } else {
      state.nextLoteId = 1;
   }
};

export const addFieldLote = (state, data) => {
   const loteId = data.id;
   const coordenadas = data.coordenadas;

   // Buscar el objeto lote correspondiente en el estado
   const loteIndex = state.lotes.findIndex((lote) => lote.id === loteId);

   // Si se encontró el objeto lote, agregar el valor
   if (loteIndex !== -1) {
      state.lotes.splice(loteIndex, 1, {
         ...state.lotes[loteIndex],
         coordsDibujo: coordenadas,
         isMapaLoaded: data.isMapaLoaded,
      });
   }
   state.lote.coordsDibujo = coordenadas;
};

export const setLoteCoords = (state, coordsDibujo) => {
   state.lote.coordsDibujo = coordsDibujo;
};

export const updateLoteCoordenadas = (state, { id, coordenadas }) => {
   const index = state.lotes.findIndex((l) => l.id_lote === id);
   if (index !== -1) {
      state.lotes[index].coordenadas = coordenadas;
   }
};

export const resetState = createResetStateMutation(getInitialStatePoliza);

export const updateLoteSwitch = (state, { loteId, switchType, value }) => {
   const loteIndex = state.lotes.findIndex((lote) =>
      loteIdsMatch(lote, loteId),
   );
   if (loteIndex !== -1) {
      state.lotes[loteIndex][switchType] = value;
   }
};
import store from '@/store';

export const setResumenPorMonedaCultivo = (state, { resumen, compania }) => {
   if (!store.state.agro.resumenPorMonedaCultivo) {
      store.state.agro.resumenPorMonedaCultivo = {};
   }
   store.state.agro.resumenPorMonedaCultivo[compania] = resumen;
};

export const setCultivoLotes = (state) => {
   const cultivo = state.lote.cultivo;
   state.lotes.forEach((lote) => {
      if (!lote.cultivo?.id_cultivo) {
         lote.cultivo = cultivo;
      }
   });
};

export const setMonedaLotes = (state) => {
   const moneda = state.lote.moneda;
   state.lotes.forEach((lote) => {
      if (!lote.moneda) {
         lote.moneda = moneda;
      }
   });
};
